// FUDR-13118: tiny flag module (no imports) so MenuPage and activateInactivityReset
// share one suppress bit without circular-dependency / duplicate-module issues.
//
// Sticky until endSuppressCartPersistAfterReset(): a timed clear (e.g. 500ms) can
// expire before React finishes route unmount cleanups, letting saveCart re-persist
// a stale cart. Cart-owning pages end suppress on mount so intentional saves work again.

let suppressCartPersistAfterReset = false;

export const shouldSuppressCartPersistAfterInactivityReset = () => suppressCartPersistAfterReset;

export const beginSuppressCartPersistAfterReset = () => {
  suppressCartPersistAfterReset = true;
};

export const endSuppressCartPersistAfterReset = () => {
  suppressCartPersistAfterReset = false;
};
